import * as React from 'react';
import { connect } from 'react-redux';

import ActionLink from 'components/buttons/action-link/ActionLink';
import { withModal } from 'components/modal/ModalHOC';
import LightweightProfileModal from './LightweightProfileModal';

import { resetDiscoveryCreatorsFilters } from 'modules/discovery/creators/reducers/creators';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./lightweight-profile-modal.json'));

type DispatchProps = {
  dispatchResetFilters: () => void
};

type Props = DispatchProps;

const ActionLinkWithLightweightProfileModal = withModal(ActionLink, {
  modalContent: LightweightProfileModal
});

class AddLightweightProfile extends React.PureComponent<Props> {
  handleSearchReset = () => {
    const { dispatchResetFilters } = this.props;

    dispatchResetFilters();
  };

  render() {
    return (
      <div className="add-lightweight-profile">
        {__t('add_influencer_profile.creator_profile_description')}
        <div className="add-lightweight-profile__link-wrapper">
          <ActionLinkWithLightweightProfileModal
            color="secondary"
            className="add-lightweight-profile__link"
            modalContentProps={{
              onProfileCreated: () => this.handleSearchReset()
            }}
          >
            {__t('add_influencer_profile.add_link')}
          </ActionLinkWithLightweightProfileModal>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchResetFilters: () => (
    dispatch(resetDiscoveryCreatorsFilters())
  )
});

export default connect(null, mapDispatchToProps)(AddLightweightProfile);
